import ajaxRequest from 'utils/_ajax-request.js'
import {loadingWindowVisible, loadingWindowHidden, loadingWindowHandler} from '4-component/loading/_index.js'

/**
 * @param {int|string} orderId
 */
export default (
  orderId,
) => {
  const button = document.getElementById('order-detail-cards__properties-btn-send')
  const textarea = document.getElementById('order-detail-cards__properties-textarea')

  if( button ) {
    button.addEventListener('click', (event)=>{
      event.preventDefault();
      let formData = new FormData()
      formData.append('additionalDescription', textarea.value);
      formData.append('orderId', orderId);

      let openUrl = '/{!_locale}/admin/orders/{!id}/additional-description'
      openUrl = openUrl.replaceAll('{!_locale}', (document.documentElement.lang || 'en'))
        .replaceAll('{!id}', orderId)

      loadingWindowVisible('process', '#page-ajax')
      ajaxRequest(
        (xhr, error) => {
          //console.log('ajax callback', xhr)
          if( error ) {
            loadingWindowHidden('process', '#page-ajax')
            loadingWindowVisible('error', '#page-ajax')
          }
          else {
            loadingWindowHidden('process', '#page-ajax')
            //loadingWindowVisible('success', '#page-ajax')
          }
        },
        (openUrl+'?ajax=1'),
        formData,
        'POST'
      )
    })
  }

}
